import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=401f2e96&scoped=true&"
import script from "./createOrder.vue?vue&type=script&lang=js&"
export * from "./createOrder.vue?vue&type=script&lang=js&"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=401f2e96&prod&lang=scss&scoped=true&"
import style1 from "./createOrder.vue?vue&type=style&index=1&id=401f2e96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401f2e96",
  null
  
)

export default component.exports